import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  title: string;
  subtitle?: string;
  crumbs: Crumb[];
}

export default function PageHero({ title, subtitle, crumbs }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-primary-950">
      <div
        className="absolute inset-0 bg-gradient-to-br from-primary-950 via-primary-900 to-primary-800"
        aria-hidden="true"
      ></div>
      <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl" aria-hidden="true"></div>
      <div className="relative mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <nav aria-label="Breadcrumb">
          <ol className="flex flex-wrap items-center gap-2 font-label text-xs text-background-300">
            {crumbs.map((crumb, index) => (
              <li key={crumb.label} className="flex items-center gap-2">
                {crumb.to ? (
                  <Link to={crumb.to} className="hover:text-accent-300">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-background-100">{crumb.label}</span>
                )}
                {index < crumbs.length - 1 ? (
                  <i className="ri-arrow-right-s-line text-background-400" aria-hidden="true"></i>
                ) : null}
              </li>
            ))}
          </ol>
        </nav>
        <h1 className="mt-4 font-heading text-3xl font-semibold leading-tight text-background-50 md:text-4xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-4 max-w-2xl font-body text-sm leading-relaxed text-background-200 md:text-base">
            {subtitle}
          </p>
        ) : null}
      </div>
    </section>
  );
}